export default {
    data() {
        return {
            commentHidden: false,
        };
    },
    computed: {},

    methods: {
        showText(event) {
            console.log(event);
            this.$refs.commentText.classList.toggle(
                't-case__commentary-text_show',
            );
        },
        hideText() {
            if (window.innerWidth < 920) {
                if (this.commentHidden) {
                    console.log(
                        this.commentHidden,
                        this.$refs.commentText,
                        this.$refs.commentText.clientHeight,
                    );
                } else {
                    console.log(
                        this.commentHidden,
                        this.$refs.commentText,
                        this.$refs.commentText.getBoundingClientRect(),
                    );

                    if (this.$refs.commentText.clientHeight > 232) {
                        this.$refs.commentText
                            .querySelector('.t-case__commentary-show-more')
                            .addEventListener('click', this.showText);
                        this.commentHidden = !this.clientHeight;
                        this.$refs.commentText.classList.toggle(
                            't-case__commentary-text_hidden',
                        );
                    }
                }
            }
        },
    },
    mounted() {
        setTimeout(() => this.hideText(), 900);
        window.addEventListener('resize', this.hideText);
    },
};
